import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { TryCatchMaterialFormsModule } from "@dodo/material-forms";
import { MatFormFieldModule } from "@angular/material/form-field";

import { MatInputModule } from "@angular/material/input";

import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";
import { ManualAddressComponent } from "./manual-address.component";
import { DodoComponentsCommonModule } from "_libs/dodo-components/dodo-components-common.module";

@NgModule({
	imports: [
		CommonModule,
		FormsModule,
		ReactiveFormsModule,
		MatFormFieldModule,
		MatProgressSpinnerModule,
		MatInputModule,
		DodoComponentsCommonModule,
		TryCatchMaterialFormsModule,
	],
	declarations: [ManualAddressComponent],
	exports: [ManualAddressComponent],
})
export class ManualAddressModule {}
